document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.card-product, [class*="card--product"]').forEach(card => {
    card.addEventListener('mouseenter', () => {
      const video = card.querySelector('video');
      if (video) {
        video.muted = true; // ensure muted for autoplay policy
        video.play().catch(() => {}); // catch prevents console errors
      }
    });

    card.addEventListener('mouseleave', () => {
      const video = card.querySelector('video');
      if (video) {
        video.pause();
        video.currentTime = 0;
      }
    });
  });
});
